import { space as styledSystemSpace } from 'styled-system';
import styled from 'styled-components';

import { breakpoints, colors } from '../../constants';
import { Flex } from '../grid';
import { pStyles } from '../typography/new/body';

const Nav = styled(Flex)`
  @media (min-width: ${breakpoints.lg}) {
    width: 100%;
  }
`;

const NavLink = styled.button`
  ${pStyles('small-semi-bold')};
  background-color: transparent;
  border: none;
  height: 100%;
  line-height: 1;
  outline: none;
  padding: 0;
  text-decoration: none;
  transition: ease 0.1s;
  white-space: nowrap;
`;

const NavItem = styled.div`
  ${styledSystemSpace}
  align-items: center;
  border-bottom: 1px solid ${colors.warmWhite3};
  display: flex;
  transition: border-bottom 0.2s ease;
  user-select: none;
  height: 100%;
  width: 100%;

  ${({ active }) =>
    active &&
    `
      background: ${colors.warmWhite3};
  `}

  &:hover {
    background: ${colors.warmWhite2};
  }

  &:last-child {
    border-bottom: none;
  }
`;

export { Nav, NavLink, NavItem };
